import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Home from "./pages/home/Home";
import Cohorts from "./pages/cohort/Cohorts";
import Dashboard from "./pages/user_dash/Dashboard";
import OrganizationDashboard from "./pages/user_dash/OrganizationDashboard";
import CohortDetails from "./pages/cohort_details/CohortDetails";

import Organizationregister from "./pages/auth/organization/Organizationregister";
import VerificationPending from "./pages/auth/organization/VerificationPending";
import VerifyEmail from "./pages/auth/organization/VerifyEmail";
import NotFound from "./pages/NotFound";
import useScrollAnimation from "./hooks/useScrollAnimation";
import MainLayout from "./layouts/MainLayout";
import AuthLayout from "./layouts/AuthLayout";
import AdminLayout from "./layouts/AdminLayout";
import DashboardLayout from "./layouts/DashboardLayout";
import OrganizationLayout from "./layouts/OrganizationLayout";
// import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import Unauthorized from "./components/auth/Unauthorized";
import MemberList from "./pages/user_dash/organization/members/MemberList";
import MemberCreate from "./pages/user_dash/organization/members/MemberCreate";
import MemberEdit from "./pages/user_dash/organization/members/MemberEdit";
import MemberShow from "./pages/user_dash/organization/members/MemberShow";
import TrainingProgramList from "./pages/user_dash/organization/traniningProgram/List";
import TrainingCohortList from "./pages/user_dash/organization/traniningProgram/TrainingCohortList";
import CohortMemberList from "./pages/user_dash/organization/traniningProgram/CohortMemberList";
import MemberTrainingList from "./pages/user_dash/organization/traniningProgram/MemberTrainingList";
import AssignCourse from "./pages/user_dash/organization/traniningProgram/AssignCourse";
import OrganizationCourseList from "./pages/user_dash/organization/traniningProgram/OrganizationCourseList";
import PaymentCallback from "./pages/user_dash/organization/traniningProgram/PaymentCallback";
import Login from "./pages/auth/Login";
import RegistrationForm from "./pages/register/Register";
import PaymentCallbackForm from "./pages/register/PaymentCallback";
import Settings from "./pages/user_dash/organization/settings/Settings.jsx";
import MyCourse from "./pages/user_dash/individual/myCourse/MyCourse.jsx";
import ClassRoom from "./pages/user_dash/individual/ClassRoom/ClassRoom.jsx";
import ForgotPassword from "./pages/auth/ForgotPassword.jsx";
import ResetPassword from "./pages/auth/ResetPassword.jsx";
import AIAssistantPage from "./pages/user_dash/AIAssistantPage.jsx";
import Profile from "./pages/user_dash/Profile.jsx";
import About from "./pages/about/About.jsx";
import RecapMaterialList from "./pages/user_dash/recapVideos/List.jsx";
import RecapMaterialOrgList from "./pages/user_dash/recapVideos/OrgList.jsx";
import RecapMaterialDetails from "./pages/user_dash/recapVideos/Details.jsx";
import RecapMaterialOrgDetails from "./pages/user_dash/recapVideos/OrgDetails.jsx";
import IndividualLibrary from "./pages/user_dash/individual/Library.jsx";
import Certificate from "./pages/user_dash/Certificate.jsx";
import Calender from "./pages/user_dash/individual/Calender/Calender";
import Faq from "./pages/faqs/Faq";
import Progress from "./pages/user_dash/Progress/Progress";
import CourseAssignments from "./pages/user_dash/Progress/CourseAssignments";
import AssignmentDetail from "./pages/user_dash/Progress/AssignmentDetail";
import Contact from "./pages/contact/Contact";
import Notifications from "./pages/user_dash/Notifications/Notifications";
import GraduatedProjects from "./pages/graduatedProjects/Graduatedproject.jsx";
import PrivateCourses from "./pages/private_courses/PrivateCourses.jsx";
import PrivateCourseDetails from "./pages/private_course_details/PrivateCourseDetails.jsx";
import Webinars from "./pages/webinar/Webinars.jsx";
import WebinarRegister from "./pages/webinar/WebinarRegister.jsx";
import OrganizationLanding from "./pages/organization/OrganizationLanding.jsx";
import RefundPolicy from "./pages/refund_policy/RefundPolicy.jsx";

function App() {
  const location = useLocation();
  useScrollAnimation(location);

  return (
    <>
      <div className="App">
        <AuthProvider>
          <div className="App">
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
            <Routes>
              <Route element={<MainLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/cohorts" element={<Cohorts />} />
                <Route
                  path="/cohorts/:slug/details"
                  element={<CohortDetails />}
                />
                <Route path="/faqs" element={<Faq />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/graduated-projects" element={<GraduatedProjects />} />
                <Route path="/private-courses" element={<PrivateCourses />} />
                <Route path="/private-courses/:slug" element={<PrivateCourseDetails />} />
                <Route path="/webinars" element={<Webinars />} />
                <Route path="/webinars/:slug" element={<WebinarRegister />} />
                <Route path="/organizations-landing" element={<OrganizationLanding />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />
              </Route>

              <Route path="cohort/register" element={<RegistrationForm />} />
              <Route
                path="/payment/callback"
                element={<PaymentCallbackForm />}
              />

              {/* Protected User Dashboard routes */}
              <Route element={<DashboardLayout />}>
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute requiredAccountType="individual">
                      {" "}
                      <Dashboard />{" "}
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/my-courses"
                  element={
                    <ProtectedRoute requiredAccountType="individual">
                      {" "}
                      <MyCourse />{" "}
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/library"
                  element={
                    <ProtectedRoute requiredAccountType="individual">
                      {" "}
                      <IndividualLibrary />{" "}
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/calendar/:startDate/:endDate"
                  element={
                    <ProtectedRoute>
                      {" "}
                      <Calender />{" "}
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/classroom/:cohortSlug"
                  element={
                    <ProtectedRoute requiredAccountType="individual">
                      {" "}
                      <ClassRoom />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/ai-assistant"
                  element={
                    <ProtectedRoute requiredAccountType="individual">
                      {" "}
                      <AIAssistantPage />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute requiredAccountType="individual">
                      {" "}
                      <Profile />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/recap-videos"
                  element={
                    <ProtectedRoute requiredAccountType="individual">
                      {" "}
                      <RecapMaterialList />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/recap-videos/:slug"
                  element={
                    <ProtectedRoute requiredAccountType="individual">
                      {" "}
                      <RecapMaterialDetails />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/certificates"
                  element={
                    <ProtectedRoute requiredAccountType="individual">
                      {" "}
                      <Certificate />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/notifications"
                  element={
                    <ProtectedRoute>
                      <Notifications />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/progress"
                  element={
                    <ProtectedRoute requiredAccountType="individual">
                      {" "}
                      <Progress />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/progress/cohort/:cohortId/assignments"
                  element={
                    <ProtectedRoute requiredAccountType="individual">
                      {" "}
                      <CourseAssignments />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/progress/enrollment/:enrollmentId/assignments"
                  element={
                    <ProtectedRoute requiredAccountType="individual">
                      {" "}
                      <CourseAssignments />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/progress/assignment/:templateId"
                  element={
                    <ProtectedRoute requiredAccountType="individual">
                      {" "}
                      <AssignmentDetail />{" "}
                    </ProtectedRoute>
                  }
                />
              </Route>

              {/* Organization routes with OrganizationLayout */}
              <Route element={<OrganizationLayout />}>
                <Route
                  path="/calendar/:startDate/:endDate"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <Calender />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/dashboard"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <OrganizationDashboard />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/progress"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <Progress />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/progress/cohort/:cohortId/assignments"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <CourseAssignments />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/progress/enrollment/:enrollmentId/assignments"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <CourseAssignments />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/progress/assignment/:templateId"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <AssignmentDetail />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/members"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <MemberList />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/members/create"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <MemberCreate />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/members/:id"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <MemberShow />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/members/:memberId/edit"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <MemberEdit />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/trainings/cohort/verify-payment/callback"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <PaymentCallback />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/training-programs"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <TrainingProgramList />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/trainings/courses"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <OrganizationCourseList />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/trainings/cohorts"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <TrainingCohortList />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/trainings/cohorts/:cohortId/members"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <CohortMemberList />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/trainings/member/:memberId"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <MemberTrainingList />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/trainings/assign"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <AssignCourse />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/trainings/assign/:memberId"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <AssignCourse />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/settings"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <Settings />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/recap-videos"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <RecapMaterialOrgList />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/recap-videos/:slug"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <RecapMaterialOrgDetails />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/certificates"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <Certificate />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/ai-assistant"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <AIAssistantPage />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organization/my-courses"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <MyCourse />{" "}
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/organization/library"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <IndividualLibrary />{" "}
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/organization/schedule"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <Calender />{" "}
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/organization/classroom/:cohortSlug"
                  element={
                    <ProtectedRoute requiredAccountType="organization">
                      {" "}
                      <ClassRoom />{" "}
                    </ProtectedRoute>
                  }
                />
              </Route>

              {/* Auth routes (login, register, etc.) */}
              <Route element={<AuthLayout />}>
                <Route
                  path="/organization/register"
                  element={<Organizationregister />}
                />
                <Route path="/verification" element={<VerificationPending />} />
                <Route path="/verify-organization" element={<VerifyEmail />} />
                <Route path="/login" element={<Login />} />
                <Route path="/organization/login" element={<Login />} />
                <Route path="/forget-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
              </Route>

              {/* Protected Admin routes */}

              {/* Unauthorized page */}
              <Route path="/unauthorized" element={<Unauthorized />} />

              {/* 404 Page - standalone without layout */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </AuthProvider>
      </div>
    </>
  );
}

export default App;
